export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.entry-c07ffa6dc86eeb66f237.worker.js");
}
